import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { AccountService } from '../../../../../services/account/account.service';
import { CallbackResult, CallbackResultStatus } from '../../../../../utils';
import { AddLocationAreaModalComponent } from './modals/add-gym-area-modal/add-location-area-modal.component';
import { EditLocationAreaModalComponent } from './modals/edit-gym-area-modal/edit-location-area-modal.component';
import { RemoveLocationAreaModalComponent } from './modals/remove-gym-area-modal/remove-location-area-modal.component';
import { LocationArea } from '../../../../../models/location';
import { LocationService } from '../../../../../services/location/location.service';
import { ApiService } from '../../../../../services/api/api.service';

@Component({
  selector: 'app-location-areas-config',
  templateUrl: './location-areas-config.component.html',
  styleUrls: ['./location-areas-config.component.css']
})
export class LocationAreasConfigComponent implements OnInit {

  public selectedLocationId: number;

  public locationAreaList: LocationArea[];

  public loadingSelectLocation = false;
  public loadingLocationAreas = true;

  public serverError: number = null;
  public errorMessage = '';

  // Make browser history available to the template.
  public history: History;

  public modalResult: CallbackResult = null;

  // Create instance references to lookup functions and enums so they may be
  // called in the template.
  public CallbackResultStatus = CallbackResultStatus;

  constructor(
    public locationService: LocationService,
    public apiService: ApiService,
    private accountService: AccountService,
    private modalService: NgbModal
  ) {}

  ngOnInit() {
    if (!this.accountService.getMyAccount().is_organization_admin) {
      this.errorMessage = 'You do not have permission to configure areas.';
      return;
    }

    this.selectedLocationId = this.accountService.getMyAccount().default_gym_id;

    // Make browser history available to the template.
    this.history = history;

    this.loadLocationAreas();
  }

  public loadLocationAreas() {
    this.loadingLocationAreas = true;

    this.serverError = null;
    this.errorMessage = '';

    this.locationService
      .getLocationAreas(
        1,
        100,
        {gym_id: this.selectedLocationId}
        )
      .then(response => { this.locationAreaList = response.results; })
      .catch(reason => {
        if (reason.status === 403) {
          this.accountService.logout();
        } else {
          this.serverError = reason.status;
        }
      })
      .finally(() => { this.loadingLocationAreas = false; });
  }

  public locationAreaResultsPresent() {
    return this.locationAreaList && (this.locationAreaList.length > 0);
  }

  public openAddLocationAreaModal() {
    this.modalResult = null;

    const modalRef = this.modalService.open(AddLocationAreaModalComponent);
    modalRef.componentInstance.locationId = this.selectedLocationId;
    modalRef.componentInstance.savedCallback = (result: CallbackResult) => {
      this.modalResult = result;
      this.loadLocationAreas();
    };
  }

  public openEditLocationAreaModal(locationArea: LocationArea) {
    // Create a copy of the location area so that the area's info is only
    // updated in the table after it is saved to the API.
    const locationAreaInput: LocationArea = {...locationArea};

    this.modalResult = null;

    const modalRef = this.modalService.open(EditLocationAreaModalComponent);
    modalRef.componentInstance.locationArea = locationAreaInput;
    modalRef.componentInstance.savedCallback = (result: CallbackResult) => {
      this.modalResult = result;
      this.loadLocationAreas();
    };
  }

  public openRemoveLocationAreaModal(locationArea: LocationArea) {
    this.modalResult = null;

    const modalRef = this.modalService.open(RemoveLocationAreaModalComponent);
    modalRef.componentInstance.locationArea = locationArea;
    modalRef.componentInstance.savedCallback = (result: CallbackResult) => {
      this.modalResult = result;
      this.loadLocationAreas();
    };
  }

  public isLoading() {
    return (
      this.loadingLocationAreas ||
      this.loadingSelectLocation
    );
  }

}
